// Generated by purs version 0.11.7
"use strict";
var otherwise = true;
module.exports = {
    otherwise: otherwise
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Boolean/index.js
// module id = 50
// module chunks = 0